export function isExternalPage() {
  var pageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return pageType.toLowerCase() === 'external';
}